<template>
  <div class="pui-wrapper browser-version">
    <div class="content">
      <i class="mdi mdi-information-outline  information-icon"></i>
      <p class="title">
        {{ $t('platform.browser_version.title') }}
      </p>
      <p class="message">
        {{ $t('platform.browser_version.message') }}
      </p>

      <ul class="download-link download-link__list">
        <li class="download-link__list-item">
          <a
            href="https://www.google.com/chrome"
            class="download-link__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="logoChrome" class="download-link__logo" />
            <i18n path="platform.browser_version.download_chrome"></i18n>
          </a>
        </li>

        <li class="download-link__list-item">
          <a
            href="https://www.mozilla.org/firefox"
            class="download-link__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="logoFirefox" class="download-link__logo" />
            <i18n path="platform.browser_version.download_firefox"></i18n>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import logoChrome from '../../static/img/chrome_logo.png';
import logoFirefox from '../../static/img/firefox_logo.png';

export default {
  data() {
    return {
      logoChrome,
      logoFirefox,
    };
  },
};
</script>
